import { onBeforeUnmount, Ref, watch } from 'vue'

type Config = {
  isOpen: Ref<boolean>,
  activator: Ref<HTMLElement | null>,
  popup: Ref<HTMLElement | null>,
  closeOnClickInside: Ref<boolean | undefined>,
  updatePosition: () => void | Promise<void>,
  close: () => void,
}

export const usePopupListeners = (config: Config) => {
  const {
    isOpen,
    activator,
    popup,
    closeOnClickInside,
    updatePosition,
    close,
  } = config

  const handleDocumentClick = (event: MouseEvent) => {
    if (!isOpen.value || !closeOnClickInside.value) {
      return
    }
    const target = event.target as Node | null
    const clickedPopup = !!(target && popup.value?.contains(target))
    if (clickedPopup) {
      close()
    }
  }

  const handleDocumentPointerDown = (event: PointerEvent) => {
    if (!isOpen.value) {
      return
    }

    const target = event.target as Node | null
    const clickedActivator = !!(target && activator.value?.contains(target))
    const clickedPopup = !!(target && popup.value?.contains(target))

    if (clickedActivator) {
      return
    }

    if (clickedPopup) {
      if (closeOnClickInside.value) {
        return
      }
      return
    }

    close()
  }

  const handleWindowUpdate = () => {
    if (isOpen.value) {
      updatePosition()
    }
  }

  watch(isOpen, (opened) => {
    if (opened) {
      updatePosition()
      document.addEventListener('pointerdown', handleDocumentPointerDown)
      if (closeOnClickInside.value) {
        document.addEventListener('click', handleDocumentClick)
      }
      window.addEventListener('resize', handleWindowUpdate)
      window.addEventListener('scroll', handleWindowUpdate, true)
      return
    }

    document.removeEventListener('pointerdown', handleDocumentPointerDown)
    document.removeEventListener('click', handleDocumentClick)
    window.removeEventListener('resize', handleWindowUpdate)
    window.removeEventListener('scroll', handleWindowUpdate, true)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('pointerdown', handleDocumentPointerDown)
    document.removeEventListener('click', handleDocumentClick)
    window.removeEventListener('resize', handleWindowUpdate)
    window.removeEventListener('scroll', handleWindowUpdate, true)
  })
}
